module.exports = __webpack_public_path__ + "static/media/role_active.3d8d32df.svg";